import { render, staticRenderFns } from "./CharactersPage.vue?vue&type=template&id=b117be20&scoped=true"
import script from "./CharactersPage.vue?vue&type=script&lang=ts"
export * from "./CharactersPage.vue?vue&type=script&lang=ts"
import style0 from "./CharactersPage.vue?vue&type=style&index=0&id=b117be20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b117be20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b117be20')) {
      api.createRecord('b117be20', component.options)
    } else {
      api.reload('b117be20', component.options)
    }
    module.hot.accept("./CharactersPage.vue?vue&type=template&id=b117be20&scoped=true", function () {
      api.rerender('b117be20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/CharactersPage.vue"
export default component.exports